import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { RenderInputWithDiv, RenderTextArea } from '../../../component/formInput';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { SocketUtils } from '../../../utils/javascriptUtils';

class ChangeTicketModal extends React.Component {

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.channel = SocketUtils.socketStore();
    this.channel.join();
  }

  sendSocketChannel = (ticket_id) => {
    const self = this;
    const { ticketModifyReload } = this.props;
    self.channel.push("tadu_customer_ticket_modify", {ticket_id: ticket_id, body: "Success To Post Ticket Comment"})
    ticketModifyReload();
  }

  socketLiveReload() {
    const self = this;
    this.channel.on("crm_ticket_modify", payload => {
      self.reload();
    })
  }


  submit(values) {
    const { ticketId, history, role_path, onHide } = this.props;
    const self = this;
    return axios({
      method: 'post',
      url: window.api_url + '/admin/api/change/ticket',
      data: {
        ticket_id: ticketId,
        title: values.title,
        note: values.note
      },
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        self.sendSocketChannel(response.data.data);
        history.push(`${role_path}/ticket/detail/${response.data.data}`)
        toast.success("Tách Ticket Thành Công !");
        onHide()
      }else {
        throw new SubmissionError(response.data.error)
      }
    })
  }
  

  handleHideModal = () => {
    const { onHide, reset } = this.props;
    reset();
    onHide();
  }

  render() {

    const { title, submitting, handleSubmit } = this.props;
    const modalConfig = { enforceFocus: false, backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    
    return (
      <Modal
        bsPrefix = "modal"
        {...modalConfig}
        dialogClassName="modal-open">
        <ToastContainer />
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-sm">{title}</Modal.Title>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.submit)}>
            <Modal.Body>
              <Field name="title" placeholder="Nhập tiêu đề cho ticket mới..." component={RenderInputWithDiv}></Field>
              <Field name="note" placeholder="Nhập ghi chú cho ticket mới..." component={RenderTextArea}></Field>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <a className="btn" onClick={this.handleHideModal}>Đóng</a>
                <button type="submit" className="btn bg-primary" disabled={submitting}>Chuyển tiếp</button>
              </div>
            </Modal.Footer>
          </form>
      </Modal>
    )
  }
}
const mapState = (state,props) => ({
  role_path: state.userProfile.role_path,

});

const mapDispatch = dispatch => ({
  ticketModifyReload: () => dispatch.messageModify.ticketModifyReload()
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'ChangeTicketModal',
    destroyOnUnmount: true,
    enableReinitialize: true,
  })(withRouter(ChangeTicketModal))));
